import React, { useState, useEffect } from "react";
import FormWizard from "./components/FormWizard/FormWizard";
import LoadLandingAnimation from "./components/BackgroundImage/BackgroundImage";
import MobileLoadLandingAnimation from "./components/MobileLandingAnimation/MobileLandingAnimation";
import OpenAiHealthCheck from "./components/OpenAIHealthCheck/OpenAIHealthCheck"

import "./App.css";
import config from "config.js";

import whiteTextLogo from "assets/logos/gustavus_reg_mark_light.svg";
import HeroHeader from "assets/headers/roar_into_the_future_desktop.svg";
import backgroundSeal from "assets/background_images/Seal_watermark.svg";
import Footer from "components/Footer/Footer";

function App() {
  const [showFormWizard, setShowFormWizard] = useState(false);
  const [appBackgroundColor, setAppBackgroundColor] = useState("primary-blue");
  const [questions, setQuestions] = useState([]);
  const [logoImage, setLogoImage] = useState(whiteTextLogo);
  const [width, setWidth] = useState(window.innerWidth);

  const MOBILE_SCREEN_SIZE = 768;

  function handleWindowSizeChange() {
    setWidth(window.innerWidth);
  }
  useEffect(() => {
    window.addEventListener("resize", handleWindowSizeChange);
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, []);


  //here's a hacky way to make the landing page not scroll on mobile!
  useEffect(() => {
    if (!showFormWizard && width > MOBILE_SCREEN_SIZE) {
      document.body.style.overflow = 'hidden';
      document.body.style.height = '100%';
      document.documentElement.style.overflow = 'hidden';
      document.documentElement.style.height = '100%';
    } else {
      document.body.style.overflow = '';
      document.body.style.height = '';
      document.documentElement.style.overflow = '';
      document.documentElement.style.height = '';
    }
  }, [showFormWizard, width]);


  // useEffect(() => {
  //   const openAIStatusCheck = async () => {
  //     const statusUrl = 'https://status.openai.com/api/v2/status.json';

  //     try {
  //       const response = await fetch(statusUrl);
  //       if (!response.ok) {
  //         throw new Error(`HTTP error! status: ${response.status}`);
  //       }
  //       const data = await response.json();
  //       const statusIndicator = data.status.indicator;
        
  //       // Check if the indicator value is not "none"
  //       if (statusIndicator !== "none") {
  //         console.log(`Service status is not normal: ${data.status.description}`);
  //       } else {
  //         console.log("All services are operating normally.");
  //       }
  //     } catch (error) {
  //       console.error("Failed to retrieve service status:", error);
  //     }
  //   };
    
  //   openAIStatusCheck();
  // }, []);



  useEffect(() => {
    const fetchData = async () => {
      try {
        const responseQuestions = await fetch(
          config.BACKEND_URL + "/data/questions"
        );

        if (!responseQuestions.ok) {
          throw new Error("Failed to fetch questions");
        }
        const dataQuestions = await responseQuestions.json();
        setQuestions(dataQuestions.questions);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);

  const handleGetStartedClick = () => {
    setShowFormWizard(true);
    setAppBackgroundColor("white");
  };

  return (
    <div className={`app ${appBackgroundColor}`}>
      <OpenAiHealthCheck/>
      {!showFormWizard ? (
        <>
          <img
            className="background-seal"
            src={backgroundSeal}
            alt="Gustavus Seal"
          ></img>

          {width <= MOBILE_SCREEN_SIZE ? (
            <MobileLoadLandingAnimation />
          ) : (
            <LoadLandingAnimation />
          )}
          <div className="homepage-static-bg-left"></div>
          <div className="homepage-static-bg-right"></div>
          <header>
            <a href={window.location}>
              <img className="header-logo" src={logoImage} alt="Logo" />
            </a>
          </header>
          <div className="landing-page">
            <img className="hero-header" src={HeroHeader} alt="Hero Header" />
            <p className="hero-text">
              Introducing, GustieBot, an AI-powered visual experience. Answer a
              few quick questions and discover just how Gusties get more out of college.
            </p>
            <div className="vertical-line"></div>
            <a
              className="button data-gtm-start"
              onClick={handleGetStartedClick}
            >
              Get started
            </a>
          </div>
          <Footer></Footer>
        </>
      ) : (
        <>
          <a href="">
            <img className="header-logo" src={logoImage} alt="Logo" />
          </a>
          <div className={`centered-container ${appBackgroundColor}`}>
            <FormWizard
              setLogoImage={setLogoImage}
              showFormWizard={showFormWizard}
              setAppBackgroundColor={setAppBackgroundColor}
              questions={questions}
            />
          </div>
        </>
      )}
    </div>
  );
}

export default App;
